"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/http");
var environment_1 = require("../../environments/environment");
var location_owner_serializer_1 = require("./location-owner.serializer");
var resource_service_1 = require("../shared/resource.service");
var LocationOwnerService = /** @class */ (function (_super) {
    __extends(LocationOwnerService, _super);
    function LocationOwnerService(http) {
        var _this = _super.call(this, http, 'locationowners/', new location_owner_serializer_1.LocationOwnerSerializer()) || this;
        _this.baseUrl = environment_1.environment.serverUrl + 'locationowners/';
        _this.search = '';
        _this.allSelected = false;
        return _this;
    }
    return LocationOwnerService;
}(resource_service_1.ResourceService));
exports.LocationOwnerService = LocationOwnerService;
